(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-customization-fields"] && !Shopify.designMode) return;
  try {
    (() => {
    const bindModule = (module) => {
      if (!module || module.dataset.customizationBound === 'true') return;

      const form = module.closest('form') || document.getElementById(module.dataset.formId || '');
      if (!form) return;

      module.dataset.customizationBound = 'true';

      const updateCount = (input) => {
        const counter = module.querySelector(`[data-customization-count][data-target="${input.id}"]`);
        if (!counter) return;
        const maxLength = input.getAttribute('maxlength') || '';
        counter.textContent = `${input.value.length}/${maxLength}`;
      };

      const syncHiddenInput = (targetId, value) => {
        if (!targetId) return;

        const hiddenInput = document.getElementById(targetId);
        if (!hiddenInput) return;

        hiddenInput.value = value;
        hiddenInput.disabled = value === '';
      };

      const syncSelectMetadata = (select) => {
        const selectedOption = select.selectedOptions && select.selectedOptions[0];
        const handleValue = selectedOption ? (selectedOption.dataset.handle || '') : '';
        const gidValue = selectedOption ? (selectedOption.dataset.gid || '') : '';

        syncHiddenInput(select.dataset.targetHandleInput || '', handleValue);
        syncHiddenInput(select.dataset.targetGidInput || '', gidValue);
      };

      module.querySelectorAll('[data-customization-count]').forEach((counter) => {
        const target = module.querySelector(`#${counter.dataset.target}`);
        if (!target) return;
        updateCount(target);
        target.addEventListener('input', () => updateCount(target));
      });

      module.querySelectorAll('[data-customization-select]').forEach((select) => {
        syncSelectMetadata(select);
        select.addEventListener('change', () => syncSelectMetadata(select));
      });

      form.addEventListener('submit', () => {
        const temporarilyDisabled = [];

        module.querySelectorAll('[data-customization-trim]').forEach((field) => {
          field.value = field.value.trim();
        });

        module.querySelectorAll('[data-customization-skip-empty="true"]').forEach((field) => {
          if (field.value.trim() !== '') return;
          field.disabled = true;
          temporarilyDisabled.push(field);
        });

        module.querySelectorAll('[data-customization-hidden-value]').forEach((field) => {
          if (field.value.trim() !== '') return;
          field.disabled = true;
          temporarilyDisabled.push(field);
        });

        if (!temporarilyDisabled.length) return;

        window.setTimeout(() => {
          temporarilyDisabled.forEach((field) => {
            field.disabled = false;
          });
        }, 0);
      }, true);
    };

    const init = (root) => {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-product-customization]').forEach(bindModule);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
